import { z } from 'zod';

const BrandPriceIdSpecialsSchema = z.object({
  brand_special_id: z.number(),
  discount_label: z.string(),
  price: z.string(),
});

export const BrandSpecialPricesSchema = z.object({
  each: BrandPriceIdSpecialsSchema.nullish(),
  half_gram: BrandPriceIdSpecialsSchema.nullish(),
  gram: BrandPriceIdSpecialsSchema.nullish(),
  two_gram: BrandPriceIdSpecialsSchema.nullish(),
  eighth_ounce: BrandPriceIdSpecialsSchema.nullish(),
  quarter_ounce: BrandPriceIdSpecialsSchema.nullish(),
  half_ounce: BrandPriceIdSpecialsSchema.nullish(),
  ounce: BrandPriceIdSpecialsSchema.nullish(),
});
